import {
  Button,
  Dialog,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Switch,
  Textarea,
  Typography
} from "@material-tailwind/react";
import Dict from "../../../helper/dict";
import React, {useEffect, useState} from "react";
import SelectInput from "../../system/select";
import "../../../style/datePicker.css"
import {getProvinceCities} from "../../../services/city/city";
import {getProvinces} from "../../../services/province/province";
import Validator from "../../../helper/validator/Validator";
import DateField from "../../system/dateField";
import {submitBackOfficePerson, updateBackOfficePerson} from "../../../services/back_office/person";
import FileInput from "../../system/fileInput";
import {Toaster} from "../../../helper/Toaster";
import {ValidatorProvider} from "../../../helper/validator/ValidatorContext";
import {checkAll} from "../../../helper/validator/Check";

export function BackOfficePersonForm({person, open, setOpen, setLastDataRefresh, setGridSelectedRow}) {
  const handleOpen = () => setOpen(!open);


  const [id, setId] = useState(person?.id ?? null)
  const [name, setName] = useState(person?.name ?? null)
  const [family, setFamily] = useState(person?.family ?? null)
  const [phone, setPhone] = useState(person?.phone ?? null)
  const [photo, setPhoto] = useState(person?.photo ?? null)
  const [status, setStatus] = useState(person?.status ?? true)
  const [personDataId, setPersonDataId] = useState(person?.person_data_id ?? null)
  const [fatherName, setFatherName] = useState(person?.father_name ?? null)
  const [nationalCode, setNationalCode] = useState(person?.national_code ?? null)
  const [birthDate, setBirthDate] = useState(person?.birth_date ?? null)
  const [gender, setGender] = useState(person?.gender ?? null)
  const [provinceId, setProvinceId] = useState(person?.province_id ?? null)
  const [cityId, setCityId] = useState(person?.city_id ?? null)
  const [homePhone, setHomePhone] = useState(person?.home_phone ?? null)
  const [email, setEmail] = useState(person?.email ?? null)
  const [address, setAddress] = useState(person?.address ?? null)

  const [password, setPassword] = useState("");
  
  const [isChecked, setIsChecked] = useState(false)

  useEffect(() => {
    setId(person?.id ?? null)
    setName(person?.name ?? null)
    setFamily(person?.family ?? null)
    setPhone(person?.phone ?? null)
    setPhoto(person?.photo ?? null)
    setStatus(person?.status !== "disable")
    setPersonDataId(person?.person_data_id ?? null)
    setFatherName(person?.father_name ?? null)
    setNationalCode(person?.national_code ?? null)
    setBirthDate(person?.birth_date ?? null)
    setGender(person?.gender ?? null)
    setProvinceId(person?.province_id ?? null)
    setCityId(person?.city_id ?? null)
    setHomePhone(person?.home_phone ?? null)
    setEmail(person?.email ?? null)
    setAddress(person?.address ?? null)
  }, [person]);

  const save = async () => {
    setIsChecked(true)
    const res = checkAll();
    if (!res) {
      Toaster.failure(null,
        <Typography variant="small">
          مقادیر الزامی را بر اساس راهنما تکمیل کنید
        </Typography>
      );
      return
    }

    const data = {
      id: id,
      name: name,
      family: family,
      phone: phone,
      photo: photo,
      status: status === true ? "enable" : "disable",
      father_name: fatherName,
      national_code: nationalCode,
      birth_date: birthDate,
      gender: gender,
      province_id: provinceId,
      city_id: cityId,
      home_phone: homePhone,
      email: email,
      address: address,
      password: password,
      person_data_id: personDataId ? parseInt(personDataId) : null,
    };
    let result;

    if (!id) {
      result = await submitBackOfficePerson(data);
    } else {
      result = await updateBackOfficePerson(data);
    }

    if (result.status === 200) {
      setGridSelectedRow(false)
      setLastDataRefresh(Date.now())
      handleOpen()
    }
  };

  return (
    <>
      <ValidatorProvider>
        <Dialog open={open} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
          <DialogHeader className="border-b">
            <Typography>ویرایش/جدید</Typography>
          </DialogHeader>
          <DialogBody className="flex flex-col gap-4 overflow-y-scroll max-h-[550px] md:max-h-[700px]">

            <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xxl:grid-cols-3">

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={name}
                       label={Dict('name')}
                       placeholder={Dict('name')}
                       onChange={(e) => {
                         setName(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={name} rules="required|alphabetic"/>
              </div>


              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={family}
                       label={Dict('family')}
                       placeholder={Dict('family')}
                       onChange={(e) => {
                         setFamily(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={family} rules="required|alphabetic"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={phone}
                       label={Dict('phone')}
                       placeholder={Dict('phone')}
                       onChange={(e) => {
                         setPhone(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={phone} rules="required|mobile"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={nationalCode}
                       label={Dict('national_code')}
                       placeholder={Dict('national_code')}
                       onChange={(e) => {
                         setNationalCode(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={nationalCode} rules="num|len=10"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={fatherName}
                       label={Dict('father_name')}
                       placeholder={Dict('father_name')}
                       onChange={(e) => {
                         setFatherName(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={fatherName} rules="alphabetic"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <DateField
                  className="my-4 mx-4 w-full"
                  date={birthDate}
                  setDate={setBirthDate}
                  label={Dict("birth_date")}
                />
                <Validator isChecked={isChecked} state={birthDate} rules=""/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Select variant="static" className="rtl" style={{label: {left: ""}}}
                        label={Dict('gender')}
                        value={gender}
                        onChange={(val) => setGender(val)}>
                  <Option value="male">مرد</Option>
                  <Option value="female">زن</Option>
                </Select>
                <Validator isChecked={isChecked} state={gender} rules=""/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={homePhone}
                       label={Dict('home_phone')}
                       placeholder={Dict('home_phone')}
                       onChange={(e) => {
                         setHomePhone(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={homePhone} rules="phoneNumber"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <Input variant="standard"
                       value={email}
                       label={Dict('email')}
                       placeholder={Dict('email')}
                       onChange={(e) => {
                         setEmail(e.target.value)
                       }}
                />
                <Validator isChecked={isChecked} state={email} rules="email"/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <SelectInput
                  className="w-full"
                  label={Dict("province")}
                  defaultValue={provinceId}
                  autoLoadService={getProvinces}
                  onChange={setProvinceId}
                />
                <Validator isChecked={isChecked} state={provinceId} rules=""/>
              </div>

              <div className="flex flex-col w-full mb-4">
                <SelectInput
                  className="w-full"
                  label={Dict("city")}
                  defaultValue={cityId}
                  refreshSignal={provinceId}
                  autoLoadService={getProvinceCities}
                  autoLoadServiceData={provinceId}
                  onChange={setCityId}
                />
                <Validator isChecked={isChecked} state={cityId} rules=""/>
              </div>

              {!id &&
                <div className="flex flex-col w-full mb-4">
                  <Input variant="standard"
                         value={password}
                         label={Dict('password')}
                         placeholder={Dict('password')}
                         onChange={(e) => {
                           setPassword(e.target.value)
                         }}
                  />
                  <Validator isChecked={isChecked} state={password} rules="password"/>
                </div>
              }

            </div>

            <div className="grid grid-cols-1 gap-6 xxl:grid-cols-3">

              <Textarea
                variant="standard"
                value={address}
                label={Dict('address')}
                onChange={(e) => {
                  setAddress(e.target.value)
                }}
              />
              <Validator isChecked={isChecked} state={address} rules=""/>

              <div className="flex flex-col w-full mb-4">
                <FileInput
                  label={Dict('profile_photo')}
                  fileCode={photo}
                  onChange={(e) => {
                    setPhoto(e.target.files[0]);
                  }}/>
                <Validator isChecked={isChecked} state={photo} rules=""/>
              </div>

            </div>

            <div className="">
              <Switch
                label={
                  <Typography color="blue-gray" className="font-medium">
                    فعال/غیرفعال
                  </Typography>
                }
                checked={status}
                value={status}
                onChange={(e) => {
                  setStatus(e.target.checked)
                }}
                labelProps={{className: "mx-4"}}
              />
            </div>

          </DialogBody>
          <DialogFooter className="space-x-2">
            <Button variant="gradient" color="gray" onClick={save} className="ml-1">
              <span>ذخیره</span>
            </Button>
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
          </DialogFooter>
        </Dialog>
      </ ValidatorProvider>
    </>
  );
}